import React, { useState, useEffect } from 'react';
import {
  useSelectFollowedGroupListByJoinedAt,
  useSelectNotFollowedGroupList,
} from 'entity/group/groupHooks';
import JoinGroupList from 'components/group/JoinGroupList';
import Button from 'app/seedly-component-library/button-new';
import { imageUrl } from 'theme';
import { useRouter } from 'next/router';
import clsx from 'clsx';

const EmptyJoinGroupCard = ({
  setSelected,
}: {
  setSelected: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <div className="flex flex-col w-full gap-4 py-6 items-center">
      <img src={imageUrl.binocular} alt="binocular" height={164} width={164} />
      <div className="flex flex-col w-full">
        <p className="text-sm font-bold text-center">
          You’ve not joined any groups.
        </p>
        <p className="text-center">
          Find groups that you like and be part of the community.
        </p>
      </div>
      <Button onClick={() => setSelected('discover-groups')}>
        Discover Groups
      </Button>
    </div>
  );
};

const EmptyJoinedAllGroupCard = () => {
  return (
    <div className="flex flex-col w-full gap-4 py-6 items-center">
      <img src={imageUrl.clapHand} alt="clap" height={164} width={164} />
      <div className="flex flex-col w-full">
        <p className="text-sm font-bold text-center">
          You’ve joined all groups!
        </p>
        <p className="text-center">
          Check back again when there are new groups to discover
        </p>
      </div>
    </div>
  );
};

const DiscoverGroupContent = () => {
  const [selected, setSelected] = useState('my-groups');
  const notFollowedGroupList = useSelectNotFollowedGroupList();
  const followedGroupList = useSelectFollowedGroupListByJoinedAt();
  const router = useRouter();
  const { discover } = router.query;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (discover === 'true') {
      setSelected('discover-groups');
    }
  }, [discover]);

  const filterList = [
    {
      title: 'My Groups',
      value: 'my-groups',
    },
    {
      title: 'Discover Groups',
      value: 'discover-groups',
    },
  ];

  return (
    <div className="flex flex-col h-fit gap-2 w-full">
      <div data-testid="discover-group-content" className="card">
        <div className="flex gap-5">
          {filterList.map(filter => {
            const isSelected = filter.value === selected;
            return (
              <span
                key={filter.title}
                className={clsx(
                  'text-sm font-bold cursor-pointer',
                  isSelected ? 'text-blue-500' : 'text-neutral-500',
                )}
                onClick={() => {
                  setSelected(filter.value);
                }}
                data-testid={`${filter.value}-filter-button`}
              >
                {filter.title}
              </span>
            );
          })}
        </div>
      </div>
      <div className="card">
        <JoinGroupList
          groupList={
            selected === 'my-groups' ? followedGroupList : notFollowedGroupList
          }
          empty={
            selected === 'my-groups' ? (
              <EmptyJoinGroupCard setSelected={setSelected} />
            ) : (
              <EmptyJoinedAllGroupCard />
            )
          }
        />
      </div>
    </div>
  );
};

export default DiscoverGroupContent;
